import React from 'react';
import { DynamicAuthProvider } from './DynamicAuthProvider';

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * Main authentication provider for PING application.
 *
 * Always uses DynamicAuthProvider which handles both single-provider (Auth0 only)
 * and multi-provider (Auth0 + Authentik) modes. When only Auth0 is configured,
 * it auto-selects Auth0 with no provider selector shown.
 */
export function AuthProvider({ children }: AuthProviderProps) {
  return (
    <DynamicAuthProvider>
      {children}
    </DynamicAuthProvider>
  );
}

// Re-export unified auth hook - use this instead of useAuth0() directly
export { useUnifiedAuth } from './DynamicAuthProvider'; 